import styled from "styled-components"

import { ButtonNew } from "components/form/ButtonNew"

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding: 12px 20px;
  border-top: 1px solid var(--border-strong);
  background: var(--surface-1);
`

const StyledMarkAllAsReadButton = styled(ButtonNew)`
  height: 32px;
  color: var(--text-secondary) !important;
  border: 1px solid var(--border-default) !important;
  padding: 0 14px !important;
  flex-shrink: 0;
`

const StyledSeeNotificationsHistoryButton = styled(ButtonNew)`
  height: 32px;
  color: var(--accent) !important;
  border: 1px solid #43e0f8 !important;
  padding: 0 14px !important;
  flex-shrink: 0;
`

interface NotificationCenterModalFooterProps {
  onMarkAllAsRead: () => void
  onSeeHistory: () => void
  isMarkingAllAsRead: boolean
  isLoading: boolean
}

export const NotificationCenterModalFooter = ({
  onMarkAllAsRead,
  onSeeHistory,
  isMarkingAllAsRead,
  isLoading,
}: NotificationCenterModalFooterProps) => {
  return (
    <Footer>
      <StyledMarkAllAsReadButton
        onClick={onMarkAllAsRead}
        disabled={isMarkingAllAsRead || isLoading}
        color="greyBordered"
      >
        Mark All as Read
      </StyledMarkAllAsReadButton>
      <StyledSeeNotificationsHistoryButton onClick={onSeeHistory} color="blueBordered">
        See Notifications History
      </StyledSeeNotificationsHistoryButton>
    </Footer>
  )
}
